/*
Suresh Peddavoora 10/31/2022 2692790263  Modified Work Queues Header and added Header Text
akhila 11/09/2022 3225733165 added tabs.
akhila 11/10/2022 3225733165 changed tabs order.
Raghu 11/16/2022 3225733165 Card Styling fixes
Ashraf 12/05/2022 3225733165 Fixed header labels
Ashraf 12/13/2022 3225733165 Renamed header labels

*/
import Tabs from './Tabs';
import { Card } from '@material-ui/core';
import { useHistory } from 'react-router';
import LandingPage from '../../LandingPage';
import React, { useContext, useEffect } from 'react';
import { ThemeContext } from '../../../../src/themes/ThemeProvider';

function index() {
  const history = useHistory();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabLabels = ['Assigned', 'Owned'];
  const { reusableInputStyles } = useContext(ThemeContext);
  const classes = reusableInputStyles();

  useEffect(() => {
    if (
      history.location.pathname === 'work-queue/owned' ||
      history.location.pathname === '/work-queue/owned'
    ) {
      setValue(1);
    } else {
      setValue(0);
    }
  }, [history.location.pathname]);

  return (
    <LandingPage
      title={'Work Queues'}
      showTabs={true}
      tabValue={value}
      handleTabChange={handleChange}
      allAntTabs={tabLabels}
    >
      <div className="global-field-dash-board">
        <Card className={`${classes.cardBordernoneStyles} rounded`}>
          <Tabs value={value} setValue={setValue} />
        </Card>
      </div>
    </LandingPage>
  );
}

export default index;
